
import { indexed, zip, ofArray, mapFold, max as max_1, averageBy, collect, average, choose, mapIndexed, skip, take, cons, allPairs, maxBy, contains, singleton, append, sortByDescending, sumBy, fold, filter, head, tail, isEmpty, length, tryItem, map as map_1, empty, tryFindIndex } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { map, delay, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { SheetInfo, CCForm, Component_$reflection, Connection, Component, PortType, Port } from "../Common/CommonTypes.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { Result_MapError, Result_Bind, Result_Map, FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { getComponentProperties } from "./Symbol.js";
import { createSymbolRecord } from "./SymbolUpdate.js";
import { DrawModelType_SymbolT_ThemeType } from "../Model/DrawModelType.js";
import { FSharpMap__get_Item, toList as toList_1, containsKey, ofList, empty as empty_1, add as add_1, tryFind } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { portNames } from "../Simulator/CanvasStateAnalyser.js";
import { tryParse } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { Record, Union, FSharpRef } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { concat, join } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { curry2, stringHash, round, safeHash, comparePrimitives, compareArrays, compare, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { record_type, class_type, float64_type, int32_type, union_type, bool_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { List_countBy, List_groupBy, List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { evaluateParamExpression, bindingsOf, parseExpression, ConstrainedExpr, ParamSlot, paramNamesOfExpr, ParameterDefs, ParamDefinition, ParamExpression, ParamName } from "../Common/ParameterTypes.js";
import { fromInt32 } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { ResultList_iter, JsonHelpers_stateToJsonString, ResultList_traverse } from "../Common/Helpers.js";
import { setSlotValue, slotApplies } from "../Common/ComponentSlots.js";
import { projectMarkerPath, writeFile, tryEnsureDirectory, saveStateToFile } from "../Interface/FilesIO.js";
import { LibraryHeader, Constants_defaultSection, Constants_currentFormatVersion, writeComponentFile } from "../Interface/ComponentLibraries.js";

export const Constants_grid = 30;

export const Constants_componentGap = 2 * Constants_grid;

export const Constants_blockGap = 3 * Constants_grid;

export const Constants_ioGap = 4 * Constants_grid;

export const Constants_margin = 2 * Constants_grid;

export const Constants_maxSwapPasses = 20;

/**
 * The id a component gets in the generated canvas: one more than its position in the
 * description's component list. Deterministic, so the same description always produces the
 * same file and fixtures can be diffed. Only per-sheet uniqueness matters at generation time -
 * the ids are renumbered into a project's namespace when the sheet is admitted to one.
 */
export function componentIdIn(sheet, compName) {
    const matchValue = tryFindIndex((c) => (c.Name === compName), sheet.Comps);
    if (matchValue == null) {
        return 0;
    }
    else {
        return (matchValue + 1) | 0;
    }
}

function labelOf(spec) {
    return defaultArg(spec.Label, spec.Name);
}

function buildComponent(compId, spec) {
    const id = compId | 0;
    const makePorts = (n, portType) => {
        const offset = ((portType.tag === 1) ? 500 : 0) | 0;
        return toList(delay(() => map((i) => (new Port(((compId * 1000) + offset) + i, i, portType, id)), rangeDouble(0, 1, n - 1))));
    };
    try {
        const patternInput = getComponentProperties(spec.Type, labelOf(spec));
        const comp = new Component(id, spec.Type, labelOf(spec), makePorts(patternInput[0], PortType.Input), makePorts(patternInput[1], PortType.Output), 0, 0, patternInput[2], patternInput[3], undefined, undefined);
        const sized = createSymbolRecord(empty(), DrawModelType_SymbolT_ThemeType.Colourful, comp);
        return new FSharpResult$2(/* Ok */ 0, [new Component(comp.Id, comp.Type, comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, sized.Component.H, sized.Component.W, comp.SymbolInfo, comp.SlotInfo)]);
    }
    catch (e) {
        return new FSharpResult$2(/* Error */ 1, [`${spec.Name}: ${spec.Type} cannot be placed on a sheet (${e.message})`]);
    }
}

function resolvePort(byName, isOutput, portRef) {
    let x, matchValue_5;
    const matchValue = tryFind(portRef.Comp, byName);
    if (matchValue != null) {
        const comp = matchValue;
        const ports = isOutput ? comp.OutputPorts : comp.InputPorts;
        const direction = isOutput ? "output" : "input";
        let names;
        const patternInput = portNames(comp.Type);
        names = map_1((n) => n.trim().toLocaleUpperCase(), isOutput ? patternInput[1] : patternInput[0]);
        const byIndex = (i) => {
            const matchValue_1 = tryItem(i, ports);
            if (matchValue_1 == null) {
                return new FSharpResult$2(/* Error */ 1, [`${portRef.Comp} has ${length(ports)} ${direction} port(s), so ${i} is out of range`]);
            }
            else {
                return new FSharpResult$2(/* Ok */ 0, [matchValue_1]);
            }
        };
        const matchValue_2 = portRef.Port;
        if (matchValue_2 === "") {
            let matchResult, only;
            if (!isEmpty(ports)) {
                if (isEmpty(tail(ports))) {
                    matchResult = 0;
                    only = head(ports);
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return new FSharpResult$2(/* Ok */ 0, [only]);
                default:
                    return new FSharpResult$2(/* Error */ 1, [`${portRef.Comp} has ${length(ports)} ${direction} ports, so one must be named: write ${portRef.Comp}/<name or number>`]);
            }
        }
        else {
            const wanted = matchValue_2;
            const matchValue_3 = tryFindIndex((x = wanted.trim().toLocaleUpperCase(), (y) => (x === y)), names);
            if (matchValue_3 == null) {
                let matchValue_4;
                let outArg = 0;
                matchValue_4 = [tryParse(wanted, 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
                    outArg = (v | 0);
                })), outArg];
                if (matchValue_4[0]) {
                    return byIndex(matchValue_4[1]);
                }
                else {
                    return new FSharpResult$2(/* Error */ 1, [`${portRef.Comp} has no ${direction} port called '${wanted}': ${(matchValue_5 = filter((n_1) => (n_1 !== ""), names), isEmpty(matchValue_5) ? (`it has no port names, so use a number 0..${length(ports) - 1}`) : ("known names are " + join(", ", matchValue_5)))}`]);
                }
            }
            else {
                return byIndex(matchValue_3);
            }
        }
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [concat("there is no component called ", portRef.Comp)]);
    }
}

function buildConnection(index, source, target) {
    return new Connection(index + 1, new Port(source.Id, undefined, source.PortType, source.HostId), new Port(target.Id, undefined, target.PortType, target.HostId), empty());
}

function weights(conns) {
    return fold((acc, conn) => {
        const b = conn.Target.HostId;
        const a = conn.Source.HostId;
        if (equals(a, b)) {
            return acc;
        }
        else {
            const key = (compare(a, b) < 0) ? [a, b] : [b, a];
            return add_1(key, 1 + defaultArg(tryFind(key, acc), 0), acc);
        }
    }, empty_1({
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }), conns);
}

function weightBetween(w, a, b) {
    return defaultArg(tryFind((compare(a, b) < 0) ? [a, b] : [b, a], w), 0) | 0;
}

function connectedOrder(w, names) {
    const degree = (name) => (sumBy((b) => (weightBetween(w, name, b) | 0), names, {
        GetZero: () => 0,
        Add: (x, y) => ((x + y) | 0),
    }) | 0);
    const walk = (ordered_mut, queue_mut, remaining_mut) => {
        walk:
        while (true) {
            const ordered = ordered_mut, queue = queue_mut, remaining = remaining_mut;
            if (!isEmpty(queue)) {
                const rest_1 = remaining;
                const next = head(queue);
                const neighbours = sortByDescending((b_1) => (weightBetween(w, next, b_1) | 0), filter((other) => (weightBetween(w, next, other) > 0), rest_1), {
                    Compare: (x_2, y_3) => (comparePrimitives(x_2, y_3) | 0),
                });
                ordered_mut = append(ordered, singleton(next));
                queue_mut = append(tail(queue), neighbours);
                remaining_mut = filter((r) => !contains(r, neighbours, {
                    Equals: equals,
                    GetHashCode: (x_3) => (safeHash(x_3) | 0),
                }), rest_1);
                continue walk;
            }
            else if (isEmpty(remaining)) {
                return ordered;
            }
            else {
                const rest = remaining;
                const seed = maxBy(degree, rest, {
                    Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                });
                ordered_mut = ordered;
                queue_mut = singleton(seed);
                remaining_mut = filter((y_2) => !equals(seed, y_2), rest);
                continue walk;
            }
            break;
        }
    };
    if (isEmpty(names)) {
        return empty();
    }
    else {
        const seed_1 = maxBy(degree, names, {
            Compare: (x_4, y_5) => (comparePrimitives(x_4, y_5) | 0),
        });
        return walk(empty(), singleton(seed_1), filter((y_6) => !equals(seed_1, y_6), names));
    }
}

function bisect(w, names) {
    const ordered = connectedOrder(w, names);
    const half = ~~(length(ordered) / 2) | 0;
    const gain = (side, other, name) => ((sumBy((b) => (weightBetween(w, name, b) | 0), other, {
        GetZero: () => 0,
        Add: (x, y) => ((x + y) | 0),
    }) - sumBy((b_1) => (weightBetween(w, name, b_1) | 0), side, {
        GetZero: () => 0,
        Add: (x_1, y_1) => ((x_1 + y_1) | 0),
    })) | 0);
    const improve = (pass_mut, a_mut, b_2_mut) => {
        improve:
        while (true) {
            const pass = pass_mut, a = a_mut, b_2 = b_2_mut;
            if (pass >= Constants_maxSwapPasses) {
                return [a, b_2];
            }
            else {
                let best;
                const _arg = map_1((tupledArg) => {
                    const x_2 = tupledArg[0];
                    const y_2 = tupledArg[1];
                    return [[x_2, y_2], (gain(a, b_2, x_2) + gain(b_2, a, y_2)) - (2 * weightBetween(w, x_2, y_2))];
                }, allPairs(a, b_2));
                best = (isEmpty(_arg) ? undefined : maxBy((tuple) => (tuple[1] | 0), _arg, {
                    Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
                }));
                let matchResult, g_1, x_5, y_5;
                if (best != null) {
                    if ((best[0][1], best[0][0], best[1] > 0)) {
                        matchResult = 0;
                        g_1 = best[1];
                        x_5 = best[0][0];
                        y_5 = best[0][1];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        pass_mut = (pass + 1);
                        a_mut = cons(y_5, filter((y_6) => !equals(x_5, y_6), a));
                        b_2_mut = cons(x_5, filter((y_7) => !equals(y_5, y_7), b_2));
                        continue improve;
                    }
                    default:
                        return [a, b_2];
                }
            }
            break;
        }
    };
    return improve(0, take(half, ordered), skip(half, ordered));
}

class Block extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Leaf", "Split"];
    }
}

function Block_$reflection() {
    return union_type("SheetLayout.Block", [], Block, () => [[["Item", Component_$reflection()]], [["IsVertical", bool_type], ["Item2", Block_$reflection()], ["Item3", Block_$reflection()]]]);
}

function verticalAffinity(isInput, isOutput, comps, conns) {
    const positionsIn = (column) => {
        const n = max(1, length(column)) | 0;
        return mapIndexed((i, c) => [c.Id, (i + 0.5) / n], column);
    };
    const pinned = ofList(append(positionsIn(filter(isInput, comps)), positionsIn(filter(isOutput, comps))), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const neighbours = fold((acc, conn) => {
        const b = conn.Target.HostId;
        const a = conn.Source.HostId;
        const add = (k, v, m) => add_1(k, cons(v, defaultArg(tryFind(k, m), empty())), m);
        return add(b, a, add(a, b, acc));
    }, empty_1({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }), conns);
    const relax = (rounds_mut, values_mut) => {
        relax:
        while (true) {
            const rounds = rounds_mut, values = values_mut;
            if (rounds === 0) {
                return values;
            }
            else {
                rounds_mut = (rounds - 1);
                values_mut = fold((acc_1, comp) => {
                    const matchValue_2 = tryFind(comp.Id, pinned);
                    if (matchValue_2 == null) {
                        const _arg = choose((n_1) => tryFind(n_1, values), defaultArg(tryFind(comp.Id, neighbours), empty()));
                        if (isEmpty(_arg)) {
                            return acc_1;
                        }
                        else {
                            return add_1(comp.Id, average(_arg, {
                                GetZero: () => 0,
                                Add: (x_3, y_2) => (x_3 + y_2),
                                DivideByInt: (x_2, i_1) => (x_2 / i_1),
                            }), acc_1);
                        }
                    }
                    else {
                        return add_1(comp.Id, matchValue_2, acc_1);
                    }
                }, values, comps);
                continue relax;
            }
            break;
        }
    };
    return relax(12, pinned);
}

function depthFromInputs(isInput, comps, conns) {
    const forward = fold((acc, conn) => {
        const key = conn.Source.HostId;
        return add_1(key, cons(conn.Target.HostId, defaultArg(tryFind(key, acc), empty())), acc);
    }, empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), conns);
    const walk = (depth_mut, frontier_mut, found_mut) => {
        walk:
        while (true) {
            const depth = depth_mut, frontier = frontier_mut, found = found_mut;
            if (isEmpty(frontier)) {
                return found;
            }
            else {
                const next = filter((name_1) => !containsKey(name_1, found), List_distinct(collect((name) => defaultArg(tryFind(name, forward), empty()), frontier), {
                    Equals: equals,
                    GetHashCode: (x_1) => (safeHash(x_1) | 0),
                }));
                depth_mut = (depth + 1);
                frontier_mut = next;
                found_mut = fold((acc_1, name_2) => add_1(name_2, depth + 1, acc_1), found, next);
                continue walk;
            }
            break;
        }
    };
    const inputs = map_1((c) => c.Id, filter(isInput, comps));
    return walk(0, inputs, ofList(map_1((name_3) => [name_3, 0], inputs), {
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    }));
}

class Ordering extends Record {
    constructor(Vertical, Depth) {
        super();
        this.Vertical = Vertical;
        this.Depth = Depth;
    }
}

function Ordering_$reflection() {
    return record_type("SheetLayout.Ordering", [], Ordering, () => [["Vertical", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, float64_type])], ["Depth", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, int32_type])]]);
}

function floorplan(w, ordering, depth, comps) {
    let _arg;
    if (!isEmpty(comps)) {
        if (isEmpty(tail(comps))) {
            return new Block(/* Leaf */ 0, [head(comps)]);
        }
        else {
            const byName = ofList(map_1((c) => [c.Id, c], comps), {
                Compare: (x, y) => (compare(x, y) | 0),
            });
            const patternInput = bisect(w, map_1((c_1) => c_1.Id, comps));
            const namesB = patternInput[1];
            const namesA = patternInput[0];
            const depthRank = (names) => averageBy((n) => defaultArg(tryFind(n, ordering.Depth), 0), names, {
                GetZero: () => 0,
                Add: (x_2, y_1) => (x_2 + y_1),
                DivideByInt: (x_1, i) => (x_1 / i),
            });
            const verticalRank = (names_1) => averageBy((n_1) => defaultArg(tryFind(n_1, ordering.Vertical), 0.5), names_1, {
                GetZero: () => 0,
                Add: (x_4, y_2) => (x_4 + y_2),
                DivideByInt: (x_3, i_1) => (x_3 / i_1),
            });
            const depthSpread = max(1, (_arg = map_1((arg) => arg[1], toList_1(ordering.Depth)), isEmpty(_arg) ? 1 : max_1(_arg, {
                Compare: (x_5, y_3) => (comparePrimitives(x_5, y_3) | 0),
            })));
            const depthDiff = Math.abs(depthRank(namesA) - depthRank(namesB)) / depthSpread;
            const verticalDiff = Math.abs(verticalRank(namesA) - verticalRank(namesB));
            let patternInput_1;
            const matchValue = depthDiff > verticalDiff;
            const matchValue_1 = verticalDiff > depthDiff;
            patternInput_1 = (matchValue ? [true, depthRank] : (matchValue_1 ? [false, verticalRank] : [(depth % 2) === 0, depthRank]));
            const rank = patternInput_1[1];
            const patternInput_2 = (rank(namesA) <= rank(namesB)) ? [namesA, namesB] : [namesB, namesA];
            const pick = (names_3) => map_1((n_2) => FSharpMap__get_Item(byName, n_2), names_3);
            const matchValue_4 = floorplan(w, ordering, depth + 1, pick(patternInput_2[0]));
            const matchValue_5 = floorplan(w, ordering, depth + 1, pick(patternInput_2[1]));
            let matchResult, a, b, only_1;
            if (matchValue_4 == null) {
                if (matchValue_5 == null) {
                    matchResult = 2;
                }
                else {
                    matchResult = 1;
                    only_1 = matchValue_5;
                }
            }
            else if (matchValue_5 == null) {
                matchResult = 1;
                only_1 = matchValue_4;
            }
            else {
                matchResult = 0;
                a = matchValue_4;
                b = matchValue_5;
            }
            switch (matchResult) {
                case 0:
                    return new Block(/* Split */ 1, [patternInput_1[0], a, b]);
                case 1:
                    return only_1;
                default:
                    return undefined;
            }
        }
    }
    else {
        return undefined;
    }
}

function blockSize(block) {
    if (block.tag === 1) {
        const patternInput = blockSize(block.fields[1]);
        const wa = patternInput[0];
        const ha = patternInput[1];
        const patternInput_1 = blockSize(block.fields[2]);
        const wb = patternInput_1[0];
        const hb = patternInput_1[1];
        if (block.fields[0]) {
            return [(wa + wb) + Constants_blockGap, max(ha, hb)];
        }
        else {
            return [max(wa, wb), (ha + hb) + Constants_blockGap];
        }
    }
    else {
        const comp = block.fields[0];
        return [comp.W + Constants_componentGap, comp.H + Constants_componentGap];
    }
}

function snap(v) {
    return round(v / Constants_grid) * Constants_grid;
}

function placeBlock(originX, originY, block) {
    if (block.tag === 1) {
        const b = block.fields[2];
        const a = block.fields[1];
        const patternInput = blockSize(a);
        if (block.fields[0]) {
            return append(placeBlock(originX, originY, a), placeBlock((originX + patternInput[0]) + Constants_blockGap, originY, b));
        }
        else {
            return append(placeBlock(originX, originY, a), placeBlock(originX, (originY + patternInput[1]) + Constants_blockGap, b));
        }
    }
    else {
        return singleton([block.fields[0].Id, snap(originX + (Constants_componentGap / 2)), snap(originY + (Constants_componentGap / 2))]);
    }
}

function placeColumn(x, startY, comps) {
    return mapFold((y, comp) => [[comp.Id, snap(x), snap(y)], (y + comp.H) + Constants_componentGap], startY, comps)[0];
}

function layout(comps, conns) {
    let plan, option_3, option_6;
    const isInput = (comp) => {
        const matchValue = comp.Type;
        switch (matchValue.tag) {
            case 0:
            case 48:
                return true;
            default:
                return false;
        }
    };
    const isOutput = (comp_1) => {
        if (comp_1.Type.tag === 1) {
            return true;
        }
        else {
            return false;
        }
    };
    const inputs = filter(isInput, comps);
    const outputs = filter(isOutput, comps);
    const body = filter((c) => {
        if (!isInput(c)) {
            return !isOutput(c);
        }
        else {
            return false;
        }
    }, comps);
    const ordering = new Ordering(verticalAffinity(isInput, isOutput, comps, conns), depthFromInputs(isInput, comps, conns));
    let bodyPlacement;
    const option_1 = floorplan(weights(conns), ordering, 0, body);
    bodyPlacement = ((option_1 != null) ? ((plan = option_1, [plan, blockSize(plan)])) : undefined);
    const patternInput = defaultArg((option_3 = bodyPlacement, (option_3 != null) ? option_3[1] : undefined), [0, 0]);
    const bodyHeight = patternInput[1];
    const columnHeight = (column) => sumBy((c_1) => (c_1.H + Constants_componentGap), column, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    });
    const contentHeight = max_1(ofArray([bodyHeight, columnHeight(inputs), columnHeight(outputs)]), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    const columnTop = (column_1) => (Constants_margin + ((contentHeight - columnHeight(column_1)) / 2));
    const bodyLeft = (Constants_margin + fold((acc, c_2) => max(acc, c_2.W), 0, inputs)) + (isEmpty(inputs) ? 0 : Constants_ioGap);
    const outputLeft = (bodyLeft + patternInput[0]) + (isEmpty(outputs) ? 0 : Constants_ioGap);
    const positions = ofList(map_1((tupledArg_1) => [tupledArg_1[0], [tupledArg_1[1], tupledArg_1[2]]], append(placeColumn(Constants_margin, columnTop(inputs), inputs), append(defaultArg((option_6 = bodyPlacement, (option_6 != null) ? placeBlock(bodyLeft, Constants_margin + ((contentHeight - bodyHeight) / 2), option_6[0]) : undefined), empty()), placeColumn(outputLeft, columnTop(outputs), outputs)))), {
        Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
    });
    return map_1((comp_2) => {
        const matchValue_2 = tryFind(comp_2.Id, positions);
        if (matchValue_2 == null) {
            return comp_2;
        }
        else {
            return new Component(comp_2.Id, comp_2.Type, comp_2.Label, comp_2.InputPorts, comp_2.OutputPorts, matchValue_2[0], matchValue_2[1], comp_2.H, comp_2.W, comp_2.SymbolInfo, comp_2.SlotInfo);
        }
    }, comps);
}

/**
 * Lay out an existing canvas: resize every component to what the app will actually draw
 * (createSymbolRecord, as buildComponent does), position the body by recursive bisection and
 * pin Inputs and Outputs to edge columns in the order they appear in the component list —
 * which therefore must be the sheet's intended port order, since a sheet's own port order is
 * read off its I/O positions. Connections are untouched: with no vertices they are re-routed
 * on load. Used by the Verilog compiler for its generated sheets.
 */
export function layoutCanvas(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const conns = _arg[1];
    return [layout(map_1((comp) => {
        const s = createSymbolRecord(empty(), DrawModelType_SymbolT_ThemeType.Colourful, comp);
        return new Component(comp.Id, comp.Type, comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, s.Component.H, s.Component.W, comp.SymbolInfo, comp.SlotInfo);
    }, _arg[0]), conns), conns];
}

/**
 * The sheet's parameter declarations and slots, as Issie stores them.
 * 
 * Slot expressions go through ParameterTypes.parseExpression - the same parser the properties
 * pane uses - so an expression means here exactly what it would mean typed into a properties box.
 * A slot naming a component that is not on the sheet, or an expression that will not parse, is an
 * error rather than something silently dropped.
 */
export function paramDefsOf(sheet) {
    const known = ofList(map_1((c) => [c.Name, c.Type], sheet.Comps), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const declarations = ofList(map_1((p) => [new ParamName(p.Name), new ParamDefinition(new ParamExpression(/* PInt */ 0, [fromInt32(p.Default)]), p.Description)], sheet.Params), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    let matchResult;
    if (isEmpty(sheet.Params)) {
        if (isEmpty(sheet.Slots)) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new FSharpResult$2(/* Ok */ 0, [undefined]);
        default:
            return Result_Map((slots) => (new ParameterDefs(declarations, ofList(slots, {
                Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
            }))), ResultList_traverse((spec) => {
                const matchValue = tryFind(spec.Comp, known);
                if (matchValue != null) {
                    if (!slotApplies(spec.Slot, matchValue)) {
                        const compType_1 = matchValue;
                        return new FSharpResult$2(/* Error */ 1, [`${spec.Comp} is a ${compType_1} and has no ${spec.Slot} slot, so no parameter can drive one`]);
                    }
                    else {
                        return Result_Bind((expr) => {
                            const matchValue_1 = filter((n) => !containsKey(n, declarations), paramNamesOfExpr(expr));
                            if (!isEmpty(matchValue_1)) {
                                return new FSharpResult$2(/* Error */ 1, [`slot expression '${spec.Expression}' on ${spec.Comp} uses '${head(matchValue_1).fields[0]}', which ${sheet.Name} does not declare`]);
                            }
                            else {
                                return new FSharpResult$2(/* Ok */ 0, [[new ParamSlot(componentIdIn(sheet, spec.Comp), spec.Slot), new ConstrainedExpr(expr, empty())]]);
                            }
                        }, Result_MapError((e) => (`slot expression '${spec.Expression}' on ${spec.Comp}: ${e}`), parseExpression(spec.Expression)));
                    }
                }
                else {
                    return new FSharpResult$2(/* Error */ 1, [concat("slot on ", spec.Comp, ", which is not a component of ", sheet.Name)]);
                }
            }, sheet.Slots));
    }
}

function applySlotValues(defs, comps) {
    if (defs != null) {
        const defs_1 = defs;
        const bindings = bindingsOf(defs_1.DefaultBindings);
        return Result_Map((resolved) => {
            const byComp = ofList(map_1((tupledArg_1) => [tupledArg_1[0], map_1((tuple_1) => tuple_1[1], tupledArg_1[1])], List_groupBy((tuple) => tuple[0], resolved, {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            })), {
                Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
            });
            return map_1((comp) => {
                const matchValue = tryFind(comp.Id, byComp);
                if (matchValue != null) {
                    return new Component(comp.Id, fold((t, tupledArg_2) => setSlotValue(tupledArg_2[0], tupledArg_2[1], t), comp.Type, matchValue), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo);
                }
                else {
                    return comp;
                }
            }, comps);
        }, ResultList_traverse((tupledArg) => {
            const slot = tupledArg[0];
            return Result_Map((value) => [slot.CompId, [slot.CompSlot, value]], Result_MapError((e) => (`slot on ${slot.CompId}: ${e}`), evaluateParamExpression(bindings, tupledArg[1].Expression)));
        }, toList_1(defs_1.ParamSlots)));
    }
    else {
        return new FSharpResult$2(/* Ok */ 0, [comps]);
    }
}

/**
 * The description as a laid-out canvas: real positions, no wire geometry.
 */
export function toCanvasState(sheet) {
    const duplicates = map_1((tuple) => tuple[0], filter((tupledArg) => (tupledArg[1] > 1), List_countBy((c) => c.Name, sheet.Comps, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })));
    if (isEmpty(duplicates)) {
        return Result_Bind((comps) => {
            const byName = ofList(map_1((tupledArg_2) => [tupledArg_2[0].Name, tupledArg_2[1]], zip(sheet.Comps, comps)), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            });
            return Result_Bind((conns) => Result_Map((comps_1) => [layout(comps_1, conns), conns], Result_Bind((defs) => applySlotValues(defs, comps), paramDefsOf(sheet))), ResultList_traverse((tupledArg_3) => {
                const conn = tupledArg_3[1];
                const matchValue = resolvePort(byName, true, conn.From);
                const matchValue_1 = resolvePort(byName, false, conn.To);
                let matchResult, source, target, e;
                const copyOfStruct = matchValue;
                if (copyOfStruct.tag === 1) {
                    matchResult = 1;
                    e = copyOfStruct.fields[0];
                }
                else {
                    const copyOfStruct_1 = matchValue_1;
                    if (copyOfStruct_1.tag === 1) {
                        matchResult = 1;
                        e = copyOfStruct_1.fields[0];
                    }
                    else {
                        matchResult = 0;
                        source = copyOfStruct.fields[0];
                        target = copyOfStruct_1.fields[0];
                    }
                }
                switch (matchResult) {
                    case 0:
                        return new FSharpResult$2(/* Ok */ 0, [buildConnection(tupledArg_3[0], source, target)]);
                    default:
                        return new FSharpResult$2(/* Error */ 1, [e]);
                }
            }, indexed(sheet.Conns)));
        }, ResultList_traverse((tupledArg_1) => buildComponent(tupledArg_1[0], tupledArg_1[1]), mapIndexed((i, spec) => [i + 1, spec], sheet.Comps)));
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [concat("these component names are used more than once: ", join(", ", duplicates))]);
    }
}

/**
 * Write the description out as a .dgm in `folder`, named after the sheet.
 * A .dgm on its own is a sheet, not a project - use saveProject to make a directory Issie can
 * open.
 */
export function saveSheet(folder, sheet) {
    return Result_Bind((canvas) => Result_Bind((defs) => saveStateToFile(folder, sheet.Name, canvas, undefined, new SheetInfo(CCForm.User, undefined, defs, false, undefined)), paramDefsOf(sheet)), toCanvasState(sheet));
}

function sheetBody(sheet) {
    return Result_Bind((canvas) => Result_Bind((defs) => JsonHelpers_stateToJsonString(canvas, undefined, new SheetInfo(CCForm.User, undefined, defs, false, undefined)), paramDefsOf(sheet)), toCanvasState(sheet));
}

/**
 * Write `sheet` into the library at `libPath` as a component offered in the catalogue, along with
 * the sheets it uses, which are written too but not offered.
 * 
 * This runs under .NET as well as in the app: a library can be built by a program without Issie
 * ever starting.
 */
export function saveLibraryComponent(libPath, description, dependencies, sheet) {
    const write = (offered, s_1) => Result_Bind((body) => writeComponentFile(libPath, new LibraryHeader(Constants_currentFormatVersion, s_1.Name, offered ? description : s_1.Name, Constants_defaultSection, offered, List_distinct(choose((c) => {
        const matchValue = c.Type;
        if (matchValue.tag === 26) {
            return matchValue.fields[0].Name;
        }
        else {
            return undefined;
        }
    }, s_1.Comps), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })), body), sheetBody(s_1));
    return Result_Bind((libPath_1) => Result_Bind(() => write(true, sheet), ResultList_iter(curry2(write)(false), dependencies)), tryEnsureDirectory(libPath));
}

/**
 * Write a whole project: every sheet, plus the empty .dprj marker that makes the directory a
 * project rather than a directory that happens to contain sheets. Issie will open a directory
 * without one, offering to put it back, but only a marked directory is recognised as a project
 * without being asked about.
 */
export function saveProject(folder, sheets) {
    const matchValue = tryEnsureDirectory(folder);
    if (matchValue.tag === 0) {
        const folder_1 = matchValue.fields[0];
        return Result_Bind(() => ResultList_iter((sheet) => saveSheet(folder_1, sheet), sheets), writeFile(projectMarkerPath(folder_1), ""));
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [matchValue.fields[0]]);
    }
}

